import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

const ReservationInfo: FC = () => {
  const { id } = useParams();
  return <></>;
};

export { ReservationInfo };
